import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

function Testimonials() {
  return (
    <>
      <section className="header-sec">
        <nav className="navbar navbar-expand-lg all">
          <ul className="navbar-nav site mr-auto mt-2 mt-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/patrons"><FormattedMessage id="page.nav-winds-patrons" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/partner"><FormattedMessage id="page.nav-winds-partner" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/digi-world"><FormattedMessage id="page.nav-winds-digi" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about-us"><FormattedMessage id="page.nav-about-us" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/luckydraw-patrons"><FormattedMessage id="page.nav-winds-luckydraw" /></Link>
            </li>
            <li className="nav-item site-active">
              <Link className="nav-link" to="/testimonials"><FormattedMessage id="page.nav-winds-testimonials" /></Link>
            </li>
          </ul>
        </nav>
      </section>
      <div className="winners-page testimonialsWrapper">
        <div className="container">
          <div className="hero">
            <div className="container text-center">
              <span>Testimonials</span>
              <h1 className="comm-head-fon">What our reward winners are saying about winds</h1>
            </div>
          </div>
          <div className="testimonials row">
            <div class="col-12 col-md-6 col-lg-4">
              <div class="testimonial">
                <div class="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/Ccyxgou_byo" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 class="mb-2">Bipul Kumar Singh, Patna (Bihar)</h5>
                <p class="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small class="text-muted">Winner for the month of January, 2023</small>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <div class="testimonial">
                <div class="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/NFcWfNcvPP4" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 class="mb-2">Prem Narayan Singh, Vegrani, Badago, Gorakhpur (Uttar Pradesh)</h5>
                <p class="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small class="text-muted">Winner for the month of January, 2023</small>
              </div>
            </div>

            <div class="col-12 col-md-6 col-lg-4">
              <div class="testimonial">
                <div class="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/X2ehyYNr3L8" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 class="mb-2">B. Amruthaiah, Nagarkurnool (Telangana)</h5>
                <p class="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small class="text-muted">Winner for the month of January, 2023</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/qPnwnGQVR4Q" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Shiva Makin, Lucknow (Uttar Pradesh)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of December, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/41Puju5fyg0" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Shiva Makin, Lucknow (Uttar Pradesh)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of December, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/C2LsZ3k6r6E" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">M. Vijay Shekhar, Hyderabad (Telangana)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of December, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/0Va2ja3rOyc" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Amit Kr. Srivastava, Lucknow (Uttar Pradesh)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of December, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/zdoTnSEvPgg" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Manoj Purohit, Jaisalmer (Rajasthan)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/2WqWT-LWX50" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Manoj Purohit, Jaisalmer (Rajasthan)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/6CSsEP9rnBc" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Rantu Hazarika, Dibrugarh (Assam)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/NnCnRbjgx2Y" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Laxmi Kumari, Hyderabad (Telangana)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/6kKSb9eI6hg" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Laxmi Kumari, Hyderabad (Telangana)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/_boeGKZR2eo" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Rina Saraf, Rourkela (Odisha)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakh</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/G44jG0vJDmM" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Sarbani Ganguly, Kolkata</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakh</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/vW7UC5nvkyg" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Umesh Pratap Singh, Pratapgarh (Uttar Pradesh)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakh</p>
                <small className="text-muted">Winner for the month of November, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/QeTjEcdoNM4" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Ashok Meena, Kota (Rajasthan)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of October, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/mO72adyi3O4" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Zeba Usmani, Ajmer (Rajasthan)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of October, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/lA0vSZwx8jE" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Ranjit Hazarika, Dibrugarh (Assam)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of October, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/6E--koZKwS8" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Nadeem Mohsin, Mumbai (Maharashtra)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of October, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/57h-XbWNM2k" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Rajeev Kumar, Jehanabad (Bihar)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of October, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/yweCITWv4wg" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Suresh Singh, Pratapgarh (Uttar Pradesh)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of October, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/gntJONLXEvk" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">J. Manzar, Delhi</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of September, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/6PEB5hpuXCA" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Rajkumar Dua, Gohana (Haryana)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of September, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/861z26aU_UQ" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Hariom Sharma, Dausa (Rajasthan)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of September, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/SgIethrViyw" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Jaya Joshi, Bhilwara (Rajasthan)</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of September, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/o6C_zz6jNXs" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Ritesh Kumar Goyal, Rajasthan</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of September, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/wLLMQM--Eqs" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">G Sathya Reddy, Telangana</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of August, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/5-8BlESXFt8" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">G Sathya Reddy, Telangana</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 25 Lakhs</p>
                <small className="text-muted">Winner for the month of August, 2022</small>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/LbIgr9G6FlM" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Anand Kumar, Varanasi, UP </h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of August, 2022</small>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/bxqd3xW2KgU" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Meet the Lucky Winners</h5>
                <p className="text-primary mb-1">Amount Won - ₹ 1 Lakh each</p>
                <small className="text-muted">Winners for the month of August, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/D6-DlJ5E5dY" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Neeraj Srivastava, Lucknow</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of July, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/r8thMNmuRBM" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Tarique Usmani, Delhi</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of July, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/FSaH-3zUQMU" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Manoj Kumar Jaiswal, Lucknow</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of July, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/b_jHosCB7rc" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mrs. Kiran Pathak, Varanasi</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of July, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/dMnAb-2qkh8" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Ravi Shankar Rajneesh, Bihar</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of July, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/_W_zy9FyWD4" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Indrasena Reddy</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of June, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/ZmNSMnQ0JU4" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Ajay Srivastava</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of June, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/y63fjHCj7iY" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Chandra Prakash Gandhi</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of June, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="image-holder mb-3">
                  <img src={require('../../assets/img/June_Winner_Ashok-Kumar-Srivastava.jpg')} alt="June_Winner_Ashok-Kumar-Srivastava" />
                </div>
                <h5 className="mb-2">Mr. Ashok Kumar Srivastava</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of June, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="image-holder mb-3">
                  <img src={require('../../assets/img/June_Winner_Laljee-Verma.jpg')} alt="June_Winner_Laljee-Verma" />
                </div>

                <h5 className="mb-2">Mr. Laljee Verma</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of June, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="image-holder mb-3">
                  <img src={require('../../assets/img/June_Winner_Sanjeev-Agarwal.jpg')} alt="June_Winner_Sanjeev-Agarwal" />
                </div>
                <h5 className="mb-2">Mr. Sanjeev Agarwal</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakhs</p>
                <small className="text-muted">Winner for the month of June, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="image-holder mb-3">
                  <img src={require('../../assets/img/June_Winner_Smita-Verma.jpg')} alt="June_Winner_Smita-Verma" />
                </div>
                <h5 className="mb-2">Mr. Smita Verma</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 50,000.00</p>
                <small className="text-muted">Winner for the month of June, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/IG6GRVNfKZo" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Nobahar</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 5 Lakhs</p>
                <small className="text-muted">Winner for the month of May, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/ZCfZEoqScRc" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Ajit Upadhyay</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 1 Lakh</p>
                <small className="text-muted">Winner for the month of May, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="embed mb-3">
                  <iframe src="https://www.youtube.com/embed/gKGWwTmht-M" title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>

                <h5 className="mb-2">Mr. Dinanath</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 50,000.00</p>
                <small className="text-muted">Winner for the month of May, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="image-holder mb-3">
                  <img src={require('../../assets/img/Ramakoteshwar-Rao.jpeg')} alt="Ramakoteshwar" />
                </div>

                <h5 className="mb-2">Mr. Ramakoteshwar Rao</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 50,000.00</p>
                <small className="text-muted">Winner for the month of May, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="image-holder mb-3">
                  <img src={require('../../assets/img/Rahul-kumar-verma.jpeg')} alt="Rahul-kumar-verma" />
                </div>

                <h5 className="mb-2">Mr. Rahul Kumar Verma</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 50,000.00</p>
                <small className="text-muted">Winner for the month of May, 2022</small>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="testimonial">
                <div className="image-holder mb-3">
                  <img src={require('../../assets/img/D-Venu-Gopal.jpg')} alt="D-Venu-Gopal" />
                </div>

                <h5 className="mb-2">Mr. D Venu Gopal</h5>
                <p className="text-primary mb-1">Amount Won : ₹ 50,000.00</p>
                <small className="text-muted">Winner for the month of May, 2022</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Testimonials;